const header = document.querySelector("[data-header]");
const menuButton = document.querySelector("[data-menu-button]");
const readTheme = () => {
  try {
    return window.localStorage.getItem("klyr-theme");
  } catch (error) {
    return null;
  }
};

const saveTheme = (theme) => {
  try {
    window.localStorage.setItem("klyr-theme", theme);
  } catch (error) {}
};

const applyTheme = (theme) => {
  const isLight = theme === "light";
  document.documentElement.classList.toggle("theme-light", isLight);
  document.body.classList.toggle("theme-light", isLight);
};

const savedTheme = readTheme();

if (savedTheme === "light") {
  applyTheme("light");
}

const syncHeader = () => {
  header?.classList.toggle("is-scrolled", window.scrollY > 12);
};

syncHeader();
window.addEventListener("scroll", syncHeader, { passive: true });

menuButton?.addEventListener("click", () => {
  const isOpen = document.body.classList.toggle("menu-open");
  menuButton?.setAttribute("aria-expanded", String(isOpen));
});

document.addEventListener("click", (event) => {
  const themeToggle = event.target.closest("[data-theme-toggle]");
  if (!themeToggle) return;

  const nextTheme = document.documentElement.classList.contains("theme-light") ? "dark" : "light";
  applyTheme(nextTheme);
  saveTheme(nextTheme);
});

document.addEventListener("click", (event) => {
  const filterButton = event.target.closest("[data-filter-category]");
  if (!filterButton) return;

  const filter = filterButton.closest("[data-collection-filter]");
  if (!filter) return;

  const category = filterButton.dataset.filterCategory;
  const buttons = [...filter.querySelectorAll("[data-filter-category]")];
  const cards = [...document.querySelectorAll("[data-product-category]")];

  buttons.forEach((item) => item.classList.toggle("is-active", item === filterButton));
  cards.forEach((card) => {
    const categories = (card.dataset.productCategory || "").split(/\s+/).filter(Boolean);
    const shouldShow = category === "all" || categories.includes(category);
    card.hidden = !shouldShow;
    card.classList.toggle("is-filtered-out", !shouldShow);
  });
});

document.querySelectorAll(".mobile-menu a").forEach((link) => {
  link.addEventListener("click", () => {
    document.body.classList.remove("menu-open");
    menuButton?.setAttribute("aria-expanded", "false");
  });
});